import { ColumnDef, SortingState } from '@tanstack/react-table';
import { InternalLifeglovUsage } from '../../api/internal';
import { useAuthentication } from '../../auth';
import { DataTable } from '../../components/DataTable';
import { SortableHeader } from '../../components/DataTable/SortableHeader';
import { Tile } from '../../components/Tile';

const columns: ColumnDef<InternalLifeglovUsage>[] = [
  {
    accessorKey: 'label',
    header: ({ column }) => <SortableHeader column={column}>Clinic</SortableHeader>
  },
  {
    accessorKey: 'totalLifeglovs',
    header: ({ column }) => <SortableHeader column={column}>Lifeglovs</SortableHeader>
  },
  {
    accessorKey: 'leftHandSmallSizeCount',
    header: ({ column }) => <SortableHeader column={column}>Left/Small</SortableHeader>
  },
  {
    accessorKey: 'leftHandMediumSizeCount',
    header: ({ column }) => <SortableHeader column={column}>Left/Medium</SortableHeader>
  },
  {
    accessorKey: 'leftHandLargeSizeCount',
    header: ({ column }) => <SortableHeader column={column}>Left/Large</SortableHeader>
  },
  {
    accessorKey: 'rightHandSmallSizeCount',
    header: ({ column }) => <SortableHeader column={column}>Right/Small</SortableHeader>
  },
  {
    accessorKey: 'rightHandMediumSizeCount',
    header: ({ column }) => <SortableHeader column={column}>Right/Medium</SortableHeader>
  },
  {
    accessorKey: 'rightHandLargeSizeCount',
    header: ({ column }) => <SortableHeader column={column}>Right/Large</SortableHeader>
  }
];

export interface LatestLifeglovUsageTileProps {
  latestLifeglovUsage: Record<string, InternalLifeglovUsage>;
  sorting: SortingState | undefined;
  onSortingChange: (sorting: SortingState) => void;
}

export function LatestLifeglovUsageTile({
  latestLifeglovUsage,
  sorting,
  onSortingChange
}: LatestLifeglovUsageTileProps) {
  const currentUser = useAuthentication();

  const rows = Object.entries(latestLifeglovUsage).map(([key, usage]) => ({
    ...usage,
    label: currentUser.subtenants?.find((s) => s.name === key)?.label ?? key
  }));

  return (
    <Tile title="Latest Lifeglov Usage">
      <DataTable
        rows={rows}
        columns={columns}
        initialSorting={sorting}
        onSortingChange={onSortingChange}
        stickyHeader
        className="pt-2"
      />
    </Tile>
  );
}
